import { Injectable, signal } from '@angular/core';
import { Router } from '@angular/router';
import { BehaviorSubject } from 'rxjs';

interface PrintJob {
  documentName: 'parcel-receipt' | 'parcel-sticker' | 'passenger-ticket' | 'future-booking-receipt';
  documentId: string;
  onPrintComplete?: () => void;
}

@Injectable({
  providedIn: 'root',
})
export class PrintService {
  isPrinting = signal(false);
  private printQueue$ = new BehaviorSubject<PrintJob[]>([]);

  constructor(private router: Router) {}

  printSingleDocument(
    documentName: 'parcel-receipt' | 'parcel-sticker' | 'passenger-ticket' | 'future-booking-receipt',
    documentId: string,
  ) {
    this.isPrinting.set(true);
    this.router.navigate([
      '/',
      {
        outlets: {
          print: ['print', documentName, documentId],
        },
      },
    ]);
  }
  printDocument(
    documentName: 'parcel-receipt' | 'parcel-sticker' | 'passenger-ticket' | 'future-booking-receipt',
    documentId: string,
    onPrintComplete?: () => void,
  ) {
    this.printQueue$.next([...this.printQueue$.value, { documentName, documentId, onPrintComplete }]);
    this.processPrintQueue();
  }

  private processPrintQueue() {
    if (this.isPrinting() || this.printQueue$.value.length === 0) {
      return;
    }

    const nextJob = this.printQueue$.value[0];
    this.isPrinting.set(true);
    this.router.navigate([
      '/',
      {
        outlets: {
          print: ['print', nextJob.documentName, nextJob.documentId],
        },
      },
    ]);
  }

  onSingleDocumentDataReady() {
    setTimeout(() => {
      window.print();
      this.isPrinting.set(false);
      this.router.navigate([{ outlets: { print: null } }]);
    }, 500);
  }

  onDataReady() {
    setTimeout(() => {
      window.print();
      this.isPrinting.set(false);
      const currentJob = this.printQueue$.value[0];
      if (currentJob.onPrintComplete) {
        currentJob.onPrintComplete();
      }
      this.printQueue$.next(this.printQueue$.value.slice(1));
      this.router.navigate([{ outlets: { print: null } }]).then(() => {
        this.processPrintQueue();
      });
    }, 500);
  }
}
